import AbstractConnector from './abstract-connector';
import { ContextService } from '../product/context';
import { ResponseData } from '.';
import { getStaticServiceData } from './connector';

export default class StaticConnector extends AbstractConnector {
	private readonly productConfig: ContextService;
	constructor(productConfig: ContextService) {
		super();
		this.productConfig = productConfig;
	}
	protected async prepareRequest() {}
	protected async sendRequest(): Promise<object> {
		return {};
	}
	protected checkResponse() {
		return true;
	}
	protected wrapRequest() {}
	protected parseResponse(): ResponseData[] {
		return getStaticServiceData(
			this.productConfig,
			this.request?.serviceEnrollments || []
		);
	}
}
